import { ArrowsRightLeftIcon } from '@heroicons/react/24/solid';
import { VersionStatistics } from '../../types';
import { styles } from './StatisticsDiagram.styles';

type StatsKeys = 'gda_summary' | 'disease' | 'vda_variant' | 'vda_disease';

const boxConfigs: { key: StatsKeys; label: string; color: string }[] = [
  {
    key: 'gda_summary',
    label: 'Gene',
    color: '#be0080',
  },
  {
    key: 'disease',
    label: 'Diseases',
    color: '#0a104f',
  },
  {
    key: 'vda_variant',
    label: 'Variants',
    color: '#925fb9',
  },
  {
    key: 'vda_disease',
    label: 'Diseases',
    color: '#0a104f',
  },
];

const StatisticsDiagram = ({ statistics }: { statistics: VersionStatistics }) => {
  return (
    <div className={styles.container}>
      {/* GDAs */}
      <div className={styles.group}>
        <div className={styles.groupTitle} style={{ color: boxConfigs[0].color }}>
          2M GDAs
        </div>
        <div className={styles.boxContainer}>
          <div className={styles.box}>
            <span className={styles.number} style={{ color: boxConfigs[0].color }}>
              {statistics?.[boxConfigs[0].key]?.toLocaleString() ?? '-'}
            </span>
            <span className={styles.label}>{boxConfigs[0].label}</span>
          </div>
          <span data-testid="icon">
            <ArrowsRightLeftIcon className={styles.arrow} />
          </span>
          <div className={styles.box}>
            <span className={styles.number} style={{ color: boxConfigs[1].color }}>
              {statistics?.[boxConfigs[1].key]?.toLocaleString() ?? '-'}
            </span>
            <span className={styles.label}>{boxConfigs[1].label}</span>
          </div>
        </div>
      </div>

      {/* VDAs */}
      <div className={styles.groupLast}>
        <div className={styles.groupTitle} style={{ color: boxConfigs[2].color }}>
          4M VDAs
        </div>
        <div className={styles.boxContainer}>
          <div className={styles.box}>
            <span className={styles.number} style={{ color: boxConfigs[2].color }}>
              {statistics?.[boxConfigs[2].key]?.toLocaleString() ?? '-'}
            </span>
            <span className={styles.label}>{boxConfigs[2].label}</span>
          </div>
          <span data-testid="icon">
            <ArrowsRightLeftIcon className={styles.arrow} />
          </span>
          <div className={styles.box}>
            <span className={styles.number} style={{ color: boxConfigs[3].color }}>
              {statistics?.[boxConfigs[3].key]?.toLocaleString() ?? '-'}
            </span>
            <span className={styles.label}>{boxConfigs[3].label}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatisticsDiagram;
